import { render, staticRenderFns } from "./TableOfContentsEntry.vue?vue&type=template&id=0c4a52fe&"
import script from "./TableOfContentsEntry.vue?vue&type=script&lang=js&"
export * from "./TableOfContentsEntry.vue?vue&type=script&lang=js&"
import style0 from "./TableOfContentsEntry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports